<template>
  <div>
    <v-toolbar
        flat
        color="white"
        rounded
    >
      <v-btn
          v-if="back"
          icon
          @click="$router.go(-1)"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title class="page-title">
        <v-skeleton-loader
            v-if="loading"
            type="heading"
            width="350"
        />
        <template v-else>
          <template v-if="edit_mode">
            <span
                v-if="!editName"
                class="primary--text user_action"
                @click="editName = true"
            >
              {{ title }}
            </span>
            <v-text-field
                v-else
                flat
                solo
                hide-details
                background-color="rgba(0, 0, 0, 0.06)"
                type="text"
                style="width: 100vh"
                v-model="newName"
                v-on:keyup.enter="updateNameEmit"
            >
              <template v-slot:append>
                <v-btn
                    text
                    small
                    color="primary"
                    @click="updateNameEmit"
                >
                  Сохранить
                </v-btn>
              </template>
            </v-text-field>
          </template>
          <template v-else>
            <span>{{ title }}</span>
          </template>
        </template>
      </v-toolbar-title>
      <v-spacer/>
      <v-btn :class="status === 2 ? 'white--text' : ''"
             :color="status === 2 ? 'thunderbird' : 'success'"
             :loading="changing"
             @click="emitClose"
             v-if="!loading && btn_closed"
      >
        <v-icon left v-text="status === 2 ? 'mdi-fire' : 'mdi-check'" /> {{ status === 2 ? 'Открыть' : 'Закрыть' }}
      </v-btn>
    </v-toolbar>
    <v-divider/>
  </div>
</template>

<script>
export default {
  name: 'PageBar',
  props: ['title', 'back', 'loading', 'btn_closed', 'status', 'changing', 'edit_mode'],
  data: () => ({
    closing: false,
    editName: false,
    initialName: null
  }),
  computed: {
    newName: {
      get () {
        return this.title
      },
      set (value) {
        this.initialName = value;
      }
    }
  },
  methods: {
    emitClose() {
      this.closing = true
      this.$emit('btn-event')
    },
    updateNameEmit() {
      this.$emit('update-name-event', this.initialName);
      this.editName = false;
      this.initialName = null;
    }
  }
}
</script>